import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

// Service
import { AuthenticationService } from 'src/app/services/authentication.service';

import { CedenteService } from 'src/app/services/cedente.service';
import { EnderecoService } from 'src/app/services/endereco.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';

// Model
import { Auth } from 'src/app/models/auth';
import { EnderecoCep, EnderecoCidade, EnderecoUf } from 'src/app/models/endereco';
import { Assignor } from 'src/app/models/assignor';
import { Address, AddressType } from 'src/app/models/address';

// Validação
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { environment } from '../../../../../../environments/environment';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { CardNameBroadcastServiceService } from 'src/app/services/card-name-broadcast-service.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { error } from 'protractor';
import { Subscription } from 'rxjs';
import { KycService } from 'src/app/services/kyc.service';
import { PersonInformation } from 'src/app/models/kyc';
import { map, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-dado-empresa-edit',
    templateUrl: './dado-empresa-edit.component.html',
    styleUrls: ['./dado-empresa-edit.component.scss'],
})
export class DadoEmpresaEditComponent implements OnInit {

    private currentUser: Auth;
    private enderecoCEP: EnderecoCep;
    private enderecoCidade: EnderecoCidade[];
    private enderecoUf: EnderecoUf[];

    private urlReturn = null;

    public MASKS = MASKS;

    canEdit = false;

    assignorFormGroup: FormGroup;
    public assignorInfo: Assignor;
    public address: Address;
    addressTypes: AddressType[] = [];

    private routeSubscriptionReturn: Subscription;

    constructor(
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute,
        private cedenteService: CedenteService,
        private formBuilder: FormBuilder,
        private enderecoService: EnderecoService,
        private cardNameBroadcastServiceService: CardNameBroadcastServiceService,
        private parametrosDataService: ParametrosDataService,
        private kycService: KycService) { }

    ngOnInit() {
        this.routeSubscriptionReturn = this.route.queryParamMap.subscribe(params => {
            if (params != null) {
                this.urlReturn = params.get('urlReturn');
            }
        });

        this.currentUser = this.authenticationService.currentUserValue;
        this.createForm(new Assignor());

        this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                this.assignorInfo = response.result;

                const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

                let str = this.assignorInfo.document.toString();

                for (let i = 0; i < tam; i++) { str = '0' + str; }
                    this.assignorInfo.document = str;

                this.createForm(new Assignor(
                    this.assignorInfo.assignorId,
                    this.assignorInfo.assignorGuid,
                    this.assignorInfo.personId,
                    null,
                    this.assignorInfo.nickName,
                    this.assignorInfo.document,
                    this.assignorInfo.companyName,
                    this.assignorInfo.tradeName,
                    this.assignorInfo.stateRegistration,
                    this.assignorInfo.municipalRegistration,
                    this.assignorInfo.openingDate,
                    this.assignorInfo.phone.toString(),
                    this.assignorInfo.email,
                ));

                this.getAddressTypes();

                this.canEdit = true;
            },
            error => {
                this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
                this.router.navigate(['detail'], { relativeTo: this.route.parent });
            }
        );
    }

    private createForm(assignor: Assignor) {
        this.assignorFormGroup = this.formBuilder.group({
            assignor: this.formBuilder.group({
                personId: assignor.personId,
                document: new FormControl(assignor.document, [
                    Validators.required,
                    NgBrazilValidators.cnpj
                ]),
                openingDate: new FormControl(assignor.openingDate!=null?new Date(assignor.openingDate): null, [
                    Validators.required,
                ]),
                tradeName: new FormControl(assignor.tradeName, [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(200)
                ]),
                companyName: new FormControl(assignor.companyName, [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(150)
                ]),
                nickName: new FormControl(assignor.nickName, [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(40)
                ]),
                stateRegistration: new FormControl(assignor.stateRegistration, [
                    Validators.maxLength(100)
                ]),
                municipalRegistration: new FormControl(assignor.municipalRegistration, [
                    Validators.required,
                    Validators.maxLength(100)
                ]),
                email: new FormControl(assignor.email, [
                    Validators.required,
                ]),
                phone: new FormControl(assignor.phone, [
                    Validators.required,
                    NgBrazilValidators.telefone
                ]),
            }),
            addresses: this.formBuilder.array([])
        });

    }

    private getAddressTypes() {
        this.cedenteService.getAddressTypes().subscribe(
            response => {
                this.addressTypes = response.result;
                this.addressTypes = this.addressTypes.filter(e => e.active).sort((a,b) => (a.addressTypeId > b.addressTypeId) ? 1 : -1);
                this.addAddresses();
            }, error => {
                this.alertService.error(error.message)
            }
        )
    }

    private addAddresses(){
        this.addressTypes?.forEach((addressType: AddressType, index) => {
            this.cedenteService.getAddress(this.currentUser.token.assignorGuid, addressType.addressTypeId).subscribe(
                response => {
                    const address = response.result;
                    const addressForm = this.formBuilder.group({
                        addressId: address?.addressId,
                        addressTypeId: addressType.addressTypeId,
                        assignorLabel: addressType.assignorLabel,
                        zipCode: new FormControl(address?.zipCode, [
                           // Validators.required,
                            Validators.maxLength(10),
                            NgBrazilValidators.cep
                        ]),
                        addressName: new FormControl(address?.addressName, [
                            Validators.maxLength(500)
                        ]),
                        number: new FormControl(address?.number, [
                            Validators.maxLength(10)
                        ]),
                        complement: new FormControl(address?.complement, [
                            Validators.maxLength(50)
                        ]),
                        neighborhood: new FormControl(address?.neighborhood, [
                            Validators.maxLength(200)
                        ]),
                        city: new FormControl(address?.city, [
                            //Validators.required
                        ]),
                        uf: new FormControl(address?.uf, [
                            //Validators.required
                        ])
                    });

                    this.addresses.insert(index, addressForm)
                }, error => {
                    this.alertService.error(error.message);
                }
            );
        });


        //this.loadList()
    }

    public get form() {
        return this.assignorFormGroup.controls;
    }

    public get addresses() {
        return this.assignorFormGroup.controls["addresses"] as FormArray;
    }

    public telefoneCelularMask = (telefone: any) => {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');
        if (telefone.length <= 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        } else if (telefone.length > 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        }
    }

    private loadList() {
        this.enderecoService.getUf().subscribe(
            response => {
                this.enderecoUf = response.result;
            }
        );
        //this.getCidade(this.address.uf);
    }

    getEndereco(zipCode: string, formGroupIndex: any) {
        if (this.addresses.controls[formGroupIndex].get('zipCode').valid && this.addresses.controls[formGroupIndex].get('zipCode').value !== null) {
            this.enderecoService.getCEP(zipCode).subscribe(
                response => {
                    if(response.status != ApiError.Sucesso){
                        this.alertService.error('CEP não localizado!');
                        this.setEndereco(formGroupIndex, null)
                    }

                    this.enderecoCEP = response.result;
                    this.setEndereco(formGroupIndex, this.enderecoCEP);

                }, error => {
                    this.alertService.error('CEP não localizado!');
                }
            );

        }
    }

    semNumero(number: any, formGroupIndex: any){
        if(number == null || number == '' || !+number){
            this.addresses.controls[formGroupIndex].get('number').setValue("S/N");
        }
    }

    setEndereco(formGroupIndex: any, enderecoCEP?: EnderecoCep) {
        if (enderecoCEP) {
            this.getCidade(enderecoCEP.uf);
            this.addresses.controls[formGroupIndex].patchValue({
                addressName: enderecoCEP.logradouro,
                neighborhood: enderecoCEP.bairro,
                city: enderecoCEP.cidade,
                uf: enderecoCEP.uf,
                zipCode: enderecoCEP.cep,
                number: 'S/N'
            });
        } else {
            this.addresses.controls[formGroupIndex].patchValue({
                addressName: null,
                neighborhood: null,
                city: null,
                uf: null,
                complement: null,
                number: 'S/N'
            });
            return;
        }

    }

    getCidade(uf: string) {
        if(uf?.replace(/\s/g,'') === '')
            uf = null;

        if (uf) {
            this.enderecoService.getCidade(uf).subscribe(
                response => {
                    this.enderecoCidade = response.result;
                },
                error => {
                    this.alertService.error('Não foi possível carregar as cidades');
                }
            );
        }
    }

    updateParametros() {
        this.cedenteService
            .getParametros(
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId
            )
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    // carregar parametros
                    this.parametrosDataService.setCurrentParametrosValue(
                        response.result
                    );
                }
            });
    }

    onSubmit(assignorInfo: any) {
        if (this.assignorFormGroup.valid) {
            assignorInfo.assignor.phone = parseInt(assignorInfo.assignor.phone.toString().replace(/\D+/g, '').replace(' ', ''));
            assignorInfo.assignor.document = parseInt(assignorInfo.assignor.document);

            const personInformation: PersonInformation = new PersonInformation(
                this.currentUser.token.pessoaId,
                assignorInfo.assignor.email,
                assignorInfo.assignor.phone,
                assignorInfo.assignor.openingDate
            );

            try {
                const addresses: Address[] = this.assignorFormGroup.controls['addresses'].value;
                addresses.forEach(element => {

                    if(element.addressId){
                        this.cedenteService.updateAddress(this.currentUser.token.assignorGuid, element).toPromise()
                            .then(
                                response => {
                                    if(response.status != ApiError.Sucesso)
                                        return this.alertService.error(response.message);
                                }
                            ).catch(error => {this.alertService.error(error.message)} )
                    }
                    if(!element.addressId && element.zipCode){
                        delete element.addressId;
                        element.personId = this.assignorInfo.personId;
                        this.cedenteService.createAddress(this.currentUser.token.assignorGuid, element).toPromise()
                            .then(
                                response => {
                                    element.addressId = response.result;

                                    if(response.status != ApiError.Sucesso)
                                        return this.alertService.error(response.message);
                                }
                            ).catch(error => {this.alertService.error(error.message)} )
                    }
                });

                this.kycService.validateAssignor(this.currentUser.token.assignorGuid, personInformation).pipe(
                    map(response => {
                            if(response.status != ApiError.Sucesso){
                                console.log(response.message)
                            }
                        }
                    ),
                    mergeMap(() => {
                        return this.cedenteService.updateAssignor(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, assignorInfo.assignor).toPromise()
                        .then(
                            response => {
                                if (response.status === ApiError.Sucesso) {
                                    this.cardNameBroadcastServiceService.SetCardName(assignorInfo.assignor.nickName);
                                    this.updateParametros();
                                    this.parametrosDataService.loadNotifications();
                                    this.alertService.success(`Dados da empresa: ${response.result.tradeName} foram editados com sucesso!`, true);
                                } else {
                                    return this.alertService.error(response.message);
                                }
                            }
                        ).catch(error => {this.alertService.error('Ocorreu um erro ao tentar editar o dados da empresa. Tente novamente mais tarde'); console.log(error.message)} )
                    }),
                ).subscribe(()=> {
                    if (this.urlReturn === null) {
                        this.router.navigate(['detail'], { relativeTo: this.route.parent });
                    } else {
                        this.router.navigate([this.urlReturn]);
                    }
                })
            }
            catch(e){
                console.log(e)
            }
        } else {
            GenericValidator.verifierValidatorsForm(this.assignorFormGroup);
        }
    }


}


